export const isHasChange = ({ changedData, data, numberFields }) => {
  for (const key in changedData) {
    if (numberFields.includes(key)) {
      if (Number(changedData[key]) !== Number(data[key])) {
        return true;
      }
    } else if ((changedData[key] ?? "") !== (data[key] ?? "")) {
      return true;
    }
  }

  return false;
};
